import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { mode } from 'crypto-js';
import { stat } from 'fs';
import { duration } from 'moment';
import { PrimeIcons } from "primeng/api";
import { PatientRegisterService } from 'src/app/screens/patient-registration/services/patient-register.service';
import { RppPatientService } from 'src/app/screens/rpp-patient-list/services/rpp-patient.service';
@Component({
  selector: 'app-patient-timeline',
  templateUrl: './patient-timeline.component.html',
  styleUrls: ['./patient-timeline.component.scss']
})
export class PatientTimelineComponent implements OnInit {

  events: any[];
  filteredEvents: any[];
  patientDetails: any;
  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLDivElement>;
  private scrollInterval: any;

  // Filter options
  stepOptions: any[] = [
    { label: 'REGISTRATION', value: 'REGISTRATION' },
    { label: 'INDUCTION', value: 'INDUCTION' },
    { label: 'OPD', value: 'OPD' },
    { label: 'RPP', value: 'RPP' },
    { label: 'ASSESSMENT', value: 'ASSESSMENT' },
    { label: 'SESSION', value: 'SESSION' }
  ];
  selectedSteps: string[] = [];

  constructor(
    private rppService: RppPatientService,
    private route: ActivatedRoute,
    private patientRegisterService: PatientRegisterService
  ) { }

  ngOnInit(): void {
    this.getPatientDetails();
   this.getPatientLifecycle();
  }

  getPatientLifecycle() {
    const patientId = this.route.snapshot.params.id;
    this.rppService.getPatientLifecycle(patientId).subscribe((res: any) => {
      this.events = res.data;
      this.filterEvents();
    });
  }

  getOpdFollowupText(event: any, events: any[]) {
    // Check if there are other objects in the events array with stepName = 'OPD' and the current event is not the last one with stepName = 'OPD'
    // Find all indices of events with stepName 'OPD'
    const opdIndices = this.events.map((e, index) => e.stepName === 'OPD' ? index : -1).filter(index => index !== -1);

    // Check if the current event's index is the last in the opdIndices array
    if (opdIndices.length > 0 && this.events[opdIndices[opdIndices.length - 1]] === event) {
      return 'OPD'; // Last OPD event
    } else {
      return 'Follow-up OPD'; // Not the last OPD event
    }
  }

  getSessionName(event) {
    if(event.filled_by_role === 'Psychiatrist') {
      return 'Psychiatrist session';
    } else if(event.filled_by_role === 'Psychologist') {
      return 'Psychologist session';
    } else if(event.filled_by_role === 'Councellor') {
      return 'Councellor session';
    } else {
      return 'Session';
    }
  }

  getPatientDetails() {
    let payload = { patient_id: this.route.snapshot.params.id }
    this.patientRegisterService.getPatientRegistration(payload).subscribe((res: any) => {      
      this.patientDetails = res;
    })
   
  }

  filterEvents() {
    if (this.selectedSteps.length === 0) {
      this.filteredEvents = this.events;
    } else {
      this.filteredEvents = this.events.filter(event => this.selectedSteps.includes(event.stepName));
    }
  }

  getCouncellorSessionCount(event) {
    if(event.services_details) {
      const councellorServices = ['Psychological Supervision', 'Daily Activities', 'Group Crt Service', 'Psychological Supervision Weekly'];
      const serviceDetails = event.services_details.find(service => councellorServices.includes(service.service_name));
      if(serviceDetails) {
        const count = {
          frequency: serviceDetails.frequency,
          doneCount: serviceDetails.doneCount
        };
        return count.doneCount + '/' + count.frequency;
      }
    } else {
      return '0/0';
    }
  }

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({ left: -100, behavior: 'smooth' });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({ left: 100, behavior: 'smooth' });
  }

  startScroll(direction: string) {
    this.stopScroll();  // Stop any existing scrolling
    const scrollAmount = direction === 'left' ? -100 : 100;

    // Set interval for continuous scrolling
    this.scrollInterval = setInterval(() => {
      this.scrollContainer.nativeElement.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }, 100);  // Adjust time interval to control scroll speed
  }

  stopScroll() {
    clearInterval(this.scrollInterval);
  }

}
